import { NewOrderDataType } from "../models/device";
import {showlog} from "../utils";

export function prepareEsolverNewCustomer(currentOrder: any) {
	try  {
	const deviceCache: NewOrderDataType = currentOrder.payload;
	const customer = deviceCache.customer
		return {
			codice_alt_one: customer?.ragioneSociale || "",
			codice_alt_two: customer?.ragioneSociale || "",
			email: customer?.email?.split(' ').join('') || '',
			codIban: customer?.codIban || '',
			indirizzo_default: 0,
			ragione_sociale: customer?.ragioneSociale,
			cond_com_per_indirizzo: 0,
			piva: customer?.piva || '',
			telefono: customer?.telefono || '',
			cellulare: customer?.cellulare || '',
			codice_fiscale: customer?.codiceFiscale || '',
			tipo_soggetto: customer?.tipoSoggetto || 4,
			web_site: '',
			note: '', // TODO recuperare?
			is_newer: true,
			id: customer?.id,
			cod_agente: parseInt(currentOrder?.company?.operatorId || "0") || 0
		}
	} catch (e: any) {
		showlog("error in prepareEsolverHeader(): ", e)
		return ""
	}
}

export function prepareEsolverNewCustomerAddress(currentOrder: any)  {
	try  {
		const deviceCache: NewOrderDataType = currentOrder.payload;
		const customer = deviceCache.customer
		const address = customer?.indirizzo
		return {
			cap: address?.cap || '',
			id: address?.id,
			via: address?.via,
			email: customer?.email?.split(' ').join('') || '',
			web_site: '',
			telefono1: customer?.telefono || '',
			telefono2: customer?.cellulare || '',
			presso: '',
			comune: address?.comune || '',
			zona: '',
			provincia: address?.codProvincia || '',
			condizione_commerciale: 0,
			cliente: customer?.id,
			categoria: customer?.categoriaClienti?.categoriaCli || '',
			categoria_sconto: '',
			SDI: address?.sdi || "",
			PEC: address?.pec?.split(' ').join('') || "",
			ragione_sociale: customer?.ragioneSociale || "",
			riferimento: '',
			tipologia_commerciale: '',
			tipo_anagrafica: 6,
			stato: customer?.stato || ""
		}
	} catch (e: any) {
		showlog("error in prepareEsolverNewCustomerAddress(): ", e)
		return ""
	}
}
